import React from "react";

const ProductsNew = React.lazy(() =>
  import("./views/Pim/Products/ProductsNew")
);
const ProductGroups = React.lazy(() =>
  import("./views/Classifiers/ProductGroups/ProductGroups")
);

const ProductGroupConatiner = React.lazy(() =>
  import("./containers/ProductGroup/ProductGroupContainer")
);
const ProductFamilies = React.lazy(() =>
  import("./views/Classifiers/ProductFamilies/ProductFamilies")
);

const ProductCategoryContainer = React.lazy(() =>
  import("./containers/ProductCategory/ProductCategoryContainer")
);

const ProductAssortments = React.lazy(() =>
  import("./views/Classifiers/ProductAssortments/ProductAssortments")
);
const ProductParameters = React.lazy(() =>
  import("./views/Classifiers/ProductParameters/ProductParameters")
);

const ProductTranslation = React.lazy(() =>
  import("./Translation/ProductTranslation")
);

const MatrixDimensions = React.lazy(() =>
  import("./views/Classifiers/MatrixDimensions/MatrixDimensions")
);

const Countries = React.lazy(() =>
  import("./views/Classifiers/Countries/Country")
);

const PriorityGroups = React.lazy(() =>
  import("./views/Classifiers/PriorityGroup/PriorityGroups")
);

const Brands = React.lazy(() =>
  import("./views/Classifiers/Brand/ProductBrand")
);

const Suppliers = React.lazy(() =>
  import("./views/Classifiers/Suppliers/ProductSuppliers")
);

const Units = React.lazy(() =>
  import("./views/Classifiers/Units/ProductUnits")
);

const Pictures = React.lazy(() =>
  import("./views/Classifiers/Pictures/Pictures")
);

const MultipleUpload = React.lazy(() =>
  import("./views/multi-upload/MultipleUpload")
);

const ExtraFields1 = React.lazy(() =>
  import("./views/Classifiers/ExtraField1/ExtraFields1")
);
const ExtraFields2 = React.lazy(() =>
  import("./views/Classifiers/ExtraField2/ExtraFields2")
);
const ExtraFields3 = React.lazy(() =>
  import("./views/Classifiers/ExtraField3/ExtraFields3")
);
const ExtraFields4 = React.lazy(() =>
  import("./views/Classifiers/ExtraField4/ExtraFields4")
);

const Settings = React.lazy(() => import("./views/settings/SettingsTab"));
const Franchise = React.lazy(() =>
  import("./views/Franchaise/FranchiseManager")
);
const ProductExport = React.lazy(() => import("./views/Export/ProductExport"));
const AssortMentExport = React.lazy(() =>
  import("./views/Export/AssortMentExport")
);
const MatrixProductExport = React.lazy(() =>
  import("./views/Export/MatrixProductExport")
);

const PricingCheckTool = React.lazy(() =>
  import("./views/Pricing/PricingCheckTool")
);

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: "/", exact: true, name: "Home" },

  { path: "/pim", exact: true, name: "PIM", component: ProductsNew },
  {
    path: "/pim/product-translation",
    exact: true,
    name: "Translations",
    component: ProductTranslation,
  },
  { path: "/pim/products", name: "Products", component: ProductsNew },
  {
    path: "/pim/product-assortments",
    exact: true,
    name: "Channels/Assortments",
    component: ProductAssortments,
  },
  {
    path: "/pim/product-parameters",
    exact: true,
    name: "Parameter Sets",
    component: ProductParameters,
  },

  {
    path: "/pim/settings",
    exact: true,
    name: "Settings",
    component: Settings,
  },

  {
    path: "/pim/franchise-reorder",
    exact: true,
    name: "Reorder Points",
    component: Franchise,
  },

  // {
  //   path: "/pim/price-check",
  //   exact: true,
  //   name: "Price Check Tool",
  //   component: PricingCheckTool,
  // },

  {
    path: "/export",
    exact: true,
    name: "Exports",
    component: ProductExport,
  },

  {
    path: "/export/product-export",
    exact: true,
    name: "Product Export",
    component: ProductExport,
  },
  {
    path: "/export/assortment-export",
    exact: true,
    name: "Assorment Export",
    component: AssortMentExport,
  },

  {
    path: "/export/matrix-product-export",
    exact: true,
    name: "Matrix Product Export",
    component: MatrixProductExport,
  },

  {
    path: "/classifiers",
    exact: true,
    name: "Classifiers",
    component: ProductGroups,
  },

  {
    path: "/pim/product-pictures",
    exact: true,
    name: "Pictures",
    component: Pictures,
  },

  {
    path: "/pim/multi-upload",
    exact: true,
    name: "MultiUpload",
    component: MultipleUpload,
  },

  {
    path: "/classifiers/product-groups",
    exact: true,
    name: "Product Groups",
    component: ProductGroupConatiner,
  },
  {
    path: "/classifiers/priority-groups",
    exact: true,
    name: "Priority Groups",
    component: PriorityGroups,
  },
  {
    path: "/classifiers/product-families",
    exact: true,
    name: "Product Families",
    component: ProductFamilies,
  },
  {
    path: "/classifiers/product-categories",
    exact: true,
    name: "Product Categories",
    component: ProductCategoryContainer,
  },

  {
    path: "/classifiers/brands",
    exact: true,
    name: "Brands",
    component: Brands,
  },

  {
    path: "/classifiers/matrix-dimensions",
    exact: true,
    name: "Matrix Dimensions",
    component: MatrixDimensions,
  },

  {
    path: "/classifiers/countries",
    exact: true,
    name: "Countries",
    component: Countries,
  },
  {
    path: "/classifiers/extra-field1",
    exact: true,
    name: "Extra-Fields-1",
    component: ExtraFields1,
  },
  {
    path: "/classifiers/extra-field2",
    exact: true,
    name: "Extra-Fields-2",
    component: ExtraFields2,
  },
  {
    path: "/classifiers/extra-field3",
    exact: true,
    name: "Extra-Fields-3",
    component: ExtraFields3,
  },
  {
    path: "/classifiers/extra-field4",
    exact: true,
    name: "Extra-Fields-4",
    component: ExtraFields4,
  },

  {
    path: "/classifiers/suppliers",
    exact: true,
    name: "Suppliers",
    component: Suppliers,
  },

  {
    path: "/classifiers/units",
    exact: true,
    name: "Units",
    component: Units,
  },
];

export default routes;
